import { defineMosaicComponent } from "@/components/Mosaic/defineMosaicComponent";

import type ManageTagsBase from "@/components/ManageTags.Base.vue";

export default defineMosaicComponent<typeof ManageTagsBase>("components/ManageTags");
